import React, { useState, useCallback, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  DatePicker,
  TreeSelect,
  Modal,
  Table,
  Image,
  Popover,
  Button,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { get, includes, map, toLower, size, join, trim } from "lodash";
import { PAGINATION } from "../../_redux/constant";
import { barrierThunks } from "../../_redux/thunk";
import { TIME_FORMAT_DATE_TIME } from "../../../app/_redux/constants";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { removeVietnameseTones } from "../../../../../lib/admin";
import {
  convertObjToArrObj,
  convertStationGate,
} from "../../../../../lib/util";
import NoImagePlaceholderBlend from "../../../../../images/NoImagePlaceholderBlend.png";
import { RANGE_PICKER_RANGES } from "app/modules/camera/_redux/constants";
import { ReloadOutlined } from "@ant-design/icons";
const IMAGE_STYLE = {
  justifySelf: "center",
  width: "95%",
  objectFit: "cover",
  borderRadius: "0.3rem",
};

let timer = null;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;
const CAMERA_STATUS = {
  OFFLINE: {
    label: "Offline",
    color: "red",
  },
  DISCONNECT: {
    label: "Disconnect",
    color: "gray",
  },
  ONLINE: {
    label: "Online",
    color: "green",
  },
};

const DIRECTION = {
  IN: "Ra",
  OUT: "Vào",
};

function BarrierHumanLogPage() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)",
  };
  const today = new Date();
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    direction,
    open_type,
    stations,
    station_gates,
    recognize_type,
  } = useSelector((state) => state.barrier.barrierLog.filterData);
  const { data, total_elements } = useSelector(
    (state) => state.barrier.barrierLog.humanLog
  );
  const [params, setParams] = useState({
    size: PAGINATION.log.size,
    page: PAGINATION.log.page,
    from: dayjs(today)
      .startOf("day")
      .toISOString(),
    to: dayjs(today)
      .endOf("day")
      .toISOString(),
  });

  const _handleChangeParam = useCallback(
    async ({ gateIds, stationIds }) => {
      let from, to;
      const { license_plate, direction, time } = form.getFieldsValue();

      if (time) {
        from = dayjs(time[0]).toISOString();
        to = dayjs(time[1]).toISOString();
      }
      setParams((prev) => ({
        ...prev,
        from,
        to,
        license_plate: license_plate
          ? license_plate.replace(/[^a-zA-Z0-9]/g, "")
          : undefined,
        direction,
        page: PAGINATION.log.page,
        size: PAGINATION.log.size,
        gate_ids:
          gateIds && size(gateIds) && size(join(gateIds, ","))
            ? join(gateIds, ",")
            : undefined,
        station_ids:
          stationIds && size(stationIds) && size(join(stationIds, ","))
            ? join(stationIds, ",")
            : undefined,
      }));
    },
    [form]
  );

  const dataSource = map(data, (item, index) => ({
    ...item,
    stt:
      params.page === 0
        ? index + 1
        : (params.page - 1) * params.size + index + 1,
  }));
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("all");

  const _handleGetLogs = useCallback(
    async () => {
      setLoading(true);
      await dispatch(barrierThunks.getHumanLogThunk(params));
      setLoading(false);
    },
    [params]
  );
  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };
  const _handleChangeFilter = () => {
    let from, to;
    let {
      username,
      direction,
      station_ids,
      time,
      open_type,
    } = form.getFieldsValue();
    username = trim(username);
    username = size(username) > 0 ? username : undefined;
    if (time) {
      from = dayjs(time[0]).toISOString();
      to = dayjs(time[1]).toISOString();
    }

    setParams((prev) => ({
      ...prev,
      from,
      to,
      station_ids:
        size(station_ids) > 0 ? join(station_ids || [], ",") : undefined,
      username,
      direction,
      open_type,
      page: PAGINATION.log.page,
      size: PAGINATION.log.size,
    }));
  };
  const _handleDisabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const onChangeTable = async (pagination) => {
    let param = {
      page: pagination.current,
      size: pagination.pageSize,
    };
    setParams((prev) => ({ ...prev, ...param }));
  };

  const getIndex = (index) => (params.page - 1) * params.size + index + 1;
  let columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "stt",
      align: "center",
      render: (_, __, index) => getIndex(index),
    },
    {
      title: "Kho",
      dataIndex: "station_name",
      align: "center",
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      align: "center",
    },
    {
      title: "Camera",
      dataIndex: "mac",
      key: "mac",
      align: "center",
    },
    {
      title: "Hướng camera",
      dataIndex: "direction",
      key: "direction",
      align: "center",
      render: (value, record) => {
        return value !== null ? direction[value] : "";
      },
    },
    {
      title: "Thời gian",
      dataIndex: "log_time",
      key: "log_time",
      align: "center",
    },

    {
      title: "Ảnh khuôn mặt",
      dataIndex: "face_image_url",
      key: "face_image_url",
      width: 120,
      align: "center",
      render: (value) => {
        return (
          <Image
            style={IMAGE_STYLE}
            src={value || NoImagePlaceholderBlend}
            fallback={NoImagePlaceholderBlend}
            height={110}
            preview={value || false}
          />
        );
      },
    },
    {
      title: "Ảnh người",
      dataIndex: "person_image_url",
      key: "person_image_url",
      width: 120,
      align: "center",
      render: (value) => {
        return (
          <Image
            style={IMAGE_STYLE}
            src={value || NoImagePlaceholderBlend}
            fallback={NoImagePlaceholderBlend}
            height={110}
            preview={value || false}
          />
        );
      },
    },
    {
      title: "Ảnh toàn cảnh",
      dataIndex: "frame_image_url",
      key: "frame_image_url",
      width: 120,
      align: "center",
      render: (value) => {
        return (
          <Image
            style={IMAGE_STYLE}
            src={value || NoImagePlaceholderBlend}
            fallback={NoImagePlaceholderBlend}
            height={110}
            preview={value || false}
          />
        );
      },
    },
  ];

  const _handleGetFilterData = useCallback(
    async () => {
      await dispatch(barrierThunks.getLogFilterDataThunk());
    },
    [dispatch]
  );
  useEffect(
    () => {
      _handleGetFilterData();
    },
    [_handleGetFilterData]
  );
  useEffect(
    () => {
      _handleGetLogs();
    },
    [_handleGetLogs]
  );

  return (
    <Row className="barrier-log__page" gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form
              form={form}
              layout={"vertical"}
              style={{ width: "100%" }}
              initialValues={{
                time: [
                  dayjs("00:00:00", "HH:mm:ss"),
                  dayjs("23:59:59", "HH:mm:ss"),
                ],
              }}
            >
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={5}>
                  <Form.Item label={"Thời gian"} name={"time"}>
                    <RangePicker
                      disabledDate={_handleDisabledDate}
                      showTime
                      presets={RANGE_PICKER_RANGES}
                      format={TIME_FORMAT_DATE_TIME}
                      onChange={_handleChangeFilter}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="station_ids"
                    colon={false}
                    label="Kho"
                    labelAlign="left"
                    labelCol={{ span: 3 }}
                  >
                    <AppBaseSelect
                      mode="multiple"
                      allowClear
                      allowConvert={true}
                      placeholder="Kho"
                      dataSource={map(station_gates, (x) => ({
                        key: x.station_id,
                        value: x.station_name,
                      }))}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={3}>
                  <Form.Item label="Username" name="username">
                    <Input
                      allowClear
                      placeholder={"Username"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row d-flex align-items-center">
                  <Button
                    className="d-flex align-items-center mr-1"
                    onClick={() => {
                      setParams((prev) => ({ ...prev }));
                    }}
                    icon={<ReloadOutlined />}
                  >
                    Làm mới
                  </Button>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          rowKey="id"
          bordered
          dataSource={dataSource}
          columns={columns}
          size="small"
          pagination={{
            current: params.page,
            pageSize: params.size,
            showSizeChanger: true,
            total: total_elements,
          }}
          onChange={onChangeTable}
        />
      </Col>
    </Row>
  );
}

export default React.memo(BarrierHumanLogPage);
